import { gql } from '@apollo/client';


export const REMOVE_NIC_ENTRY = gql`
  mutation removeNicEntryFromIncident($input: RemoveNicEntryFromIncidentInput!) {
    removeNicEntryFromIncident(input: $input) {
      clientMutationId
      errors
    }
  }
`

// Example input:
// {
//   "input": {
//     "nicId": ID!
//     "originatorId": ID!
//     "clientMutationId": String
//   }
// }